import React from 'react';

/**
 * Form wrapper component
 * @param {Function} onSubmit - the submit event handler
 * @param {children} children - JSX
 * @param {string} className - CSS classes
 */
const Form = ({ onSubmit, children, className }) => (
  <form onSubmit={onSubmit} className={className}>
    {children}
  </form>
);

export default Form;
